import { render, staticRenderFns } from "./BannerMedia.vue?vue&type=template&id=0bf3f442&scoped=true&"
import script from "./BannerMedia.vue?vue&type=script&lang=js&"
export * from "./BannerMedia.vue?vue&type=script&lang=js&"
import style0 from "./BannerMedia.vue?vue&type=style&index=0&id=0bf3f442&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf3f442",
  null
  
)

export default component.exports